import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  actionTo?: string;
  actionLabel?: string;
  center?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, actionTo, actionLabel, center }: Props) {
  return (
    <div className={`flex flex-col gap-3 ${center ? 'items-center text-center' : 'sm:flex-row sm:items-end sm:justify-between'}`}>
      <div className={center ? 'mx-auto max-w-2xl' : 'max-w-2xl'}>
        {eyebrow && (
          <div className="mb-2 flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-accent-600">
            <span className="inline-flex h-1.5 w-6 items-center rounded-full bg-accent-500" aria-hidden="true" />
            {eyebrow}
          </div>
        )}
        <h2 className="font-heading text-2xl font-black leading-tight text-foreground-900 md:text-[2rem]">{title}</h2>
        {desc && <p className="mt-2 text-sm leading-6 text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {actionTo && actionLabel && (
        <Link
          to={actionTo}
          className="group inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-600"
        >
          {actionLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}